import { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

function FAQAccordion({ faqs, onToggle }) {
  const [expanded, setExpanded] = useState(null);

  return (
    <div>
      {faqs.map((faq, index) => (
        <Accordion
          key={faq.question}
          variant="outlined"
          expanded={expanded === index}
          onChange={() => {
            const opening = expanded !== index;
            setExpanded(opening ? index : null);
            onToggle?.(faq, opening);
          }}
          sx={{ '&:before': { display: 'none' } }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`faq-panel-${index}`} id={`faq-header-${index}`}>
            <Typography fontWeight={600}>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography color="text.secondary">{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}

export default FAQAccordion;
